/* custom-deskshelf-v2.js — gedrag voor de Desk Shelf-PDP-sectie (zustersectie van
   de stoel-v2). Theme-vertaling van assets/shelf.js uit het goedgekeurde design
   (Design-Specialist/werk/deskshelves-pdp-v2), plus echte winkelwagen-koppeling
   (zelfde flow als custom-stoel.js: fetch /cart/add.js + Symmetry-events).
   Volgt de DS-klassecontracten: .js op <html>, .rv/.hero-orch -> .is-in,
   .stickybar.is-in + inert (K-R9-03: transitieloos), .sheet.is-open,
   .acc__item.is-open, data-active-topic, .pdet--js, .mq--statisch, navlinks--eind.
   Sticky via scroll-listener, niet IntersectionObserver: een instant-jump
   (ankerlink) kruist geen IO-drempel (gemeten, design-sweep 11-08). */
(function () {
  'use strict';
  document.documentElement.classList.add('js');

  var root = document.querySelector('.stoel-pdp');
  if (!root) return;

  var dataNode = document.querySelector('.deskshelf-pdp-data');
  var DATA = {};
  try { DATA = JSON.parse(dataNode ? dataNode.textContent : '{}'); } catch (e) { DATA = {}; }
  var PRIJS = DATA.model && DATA.model.prijs ? DATA.model.prijs : 0;
  var WAS = DATA.model && DATA.model.was ? DATA.model.was : 0;
  var motionOk = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function euro(cents) {
    var e = Math.floor(cents / 100), c = String(cents % 100).padStart(2, '0');
    return '€' + e.toLocaleString('nl-NL') + ',' + c;
  }

  /* ── toast ── */
  var toastNode = root.querySelector('[data-toast-node]');
  var toastTimer = null;
  function toast(msg) {
    if (!toastNode) return;
    toastNode.textContent = msg;
    toastNode.classList.add('is-in');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastNode.classList.remove('is-in'); }, 2600);
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-toast]');
    if (t) { e.preventDefault(); toast(t.getAttribute('data-toast')); }
  });

  /* ── winkelwagen (custom-stoel.js-flow: AJAX + Symmetry-events) ── */
  var bezig = false;
  function toevoegen(items, omschrijving) {
    if (bezig) return Promise.resolve();
    bezig = true;
    root.classList.add('is-busy');
    return fetch((DATA.routes && DATA.routes.cartAdd ? DATA.routes.cartAdd : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          toast(res.body && res.body.description ? res.body.description : 'Dit lukte niet. Probeer het nog een keer.');
          return;
        }
        toast(omschrijving + ' toegevoegd aan je winkelwagen.');
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, detail: { cart: res.body } }));
        document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { cart: res.body } }));
      })
      .catch(function () { toast('Dit lukte niet. Probeer het nog een keer.'); })
      .then(function () { bezig = false; root.classList.remove('is-busy'); });
  }

  /* ── ATC: het verborgen formulier werkt zonder JS (echte POST); mét JS
     onderscheppen we hem en voegen we AJAX toe. ── */
  var atcForm = document.querySelector('form[data-ds-atc]');
  var qty = 1;
  if (atcForm) atcForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var vid = parseInt(atcForm.querySelector('[data-atc-variant]').value, 10);
    if (!vid) { toast('Dit product is nog niet te bestellen.'); return; }
    toevoegen([{ id: vid, quantity: qty }], (DATA.model && DATA.model.naam) || 'Desk Shelf');
    sluitSheet();
  });

  /* ── reveal on scroll (CSS draagt de transitie; vangnet na 2200 ms) ── */
  var revs = [].slice.call(document.querySelectorAll('.rv, .hero-orch'));
  if ('IntersectionObserver' in window) {
    var revIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); revIO.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    revs.forEach(function (el) { revIO.observe(el); });
  }
  setTimeout(function () { revs.forEach(function (el) { el.classList.add('is-in'); }); }, 2200);

  /* ── galerij ── */
  var gal = root.querySelector('[data-gal]');
  if (gal) {
    var track = gal.querySelector('[data-gal-track]');
    var slides = [].slice.call(track.children);
    var thumbs = [].slice.call(gal.querySelectorAll('[data-gal-thumb]'));
    var dots = [].slice.call(gal.querySelectorAll('[data-gal-dot]'));
    var count = gal.querySelector('[data-gal-count]');
    var cur = 0;
    function slideBreedte() { return slides[0] ? slides[0].getBoundingClientRect().width : track.clientWidth; }
    function gaNaar(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * slideBreedte(), behavior: motionOk ? 'smooth' : 'auto' });
    }
    function zetCur(i) {
      if (i === cur) return;
      cur = i;
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      dots.forEach(function (d, n) { d.classList.toggle('is-cur', n === i); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
    }
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / Math.max(1, slideBreedte()));
      zetCur(Math.max(0, Math.min(slides.length - 1, i)));
    }, { passive: true });
    gal.querySelector('[data-gal-prev]').addEventListener('click', function () { gaNaar(cur - 1); });
    gal.querySelector('[data-gal-next]').addEventListener('click', function () { gaNaar(cur + 1); });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { gaNaar(n); }); });
    /* --galov-h: TP-pil + teller ankeren óp het beeld, niet op de thumbnails
       (ds-mechanisme; JS zet de trackhoogte, ResizeObserver houdt hem bij). */
    function zetGalovH() { gal.style.setProperty('--galov-h', track.getBoundingClientRect().height + 'px'); }
    if ('ResizeObserver' in window) new ResizeObserver(zetGalovH).observe(track);
    zetGalovH();
  }

  /* ── sleepbare rails (galerij, reviews, cross-sell) ── */
  [].slice.call(document.querySelectorAll('[data-sleepbaar]')).forEach(function (rail) {
    var down = false, startX = 0, startL = 0, moved = false;
    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = false; startX = e.clientX; startL = rail.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 6) moved = true;
      rail.scrollLeft = startL - dx;
    });
    window.addEventListener('pointerup', function () { down = false; });
    rail.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  });

  /* ── aantal + prijs-slots (één bron: de productprijs uit Shopify) ── */
  var qtyOut = root.querySelector('[data-qty-out]');
  var calcRow = root.querySelector('[data-price-calc]');
  function renderPrijs() {
    var totaal = PRIJS * qty;
    [].slice.call(root.querySelectorAll('[data-atc-amt]')).forEach(function (el) { el.textContent = euro(totaal); });
    /* R5: [data-sticky-price] staat er nu TWEE keer — in de prijsgroep (desktop) en in
       het knoplabel (mobiel). querySelector pakte alleen de eerste, waardoor het bedrag
       in de knop op de basisprijs bleef staan zodra je het aantal ophoogde. */
    [].slice.call(root.querySelectorAll('[data-sticky-price]')).forEach(function (el) { el.textContent = euro(totaal); });
    var stickyQty = root.querySelector('[data-sticky-qty]');
    if (stickyQty) { stickyQty.hidden = qty < 2; stickyQty.textContent = qty + ' stuks ·'; }
    var stickyWas = root.querySelector('[data-sticky-was-amt]');
    if (stickyWas && WAS) stickyWas.textContent = euro(WAS * qty);
    if (calcRow) {
      if (qty >= 2) {
        calcRow.hidden = false;
        calcRow.querySelector('[data-calc-l]').textContent = qty + ' × ' + euro(PRIJS);
        calcRow.querySelector('[data-calc-r]').textContent = euro(totaal);
      } else { calcRow.hidden = true; }
    }
    var q = document.querySelector('[data-atc-qty]');
    if (q) q.value = String(qty);
  }
  [].slice.call(root.querySelectorAll('[data-qty]')).forEach(function (b) {
    b.addEventListener('click', function () {
      qty = Math.max(1, Math.min(9, qty + parseInt(b.getAttribute('data-qty'), 10)));
      if (qtyOut) qtyOut.textContent = String(qty);
      renderPrijs();
    });
  });
  renderPrijs();

  /* ── ankernav: scrollspy + fade-cue op overloop ── */
  var nav = root.querySelector('[data-ankernav]');
  if (nav) {
    var links = [].slice.call(nav.querySelectorAll('a[href^="#sec-"]'));
    var secties = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); }).filter(Boolean);
    function spy() {
      var y = window.scrollY + 140;
      var actief = 0;
      secties.forEach(function (s, i) { if (s.offsetTop <= y) actief = i; });
      links.forEach(function (a, i) { a.setAttribute('aria-current', i === actief ? 'true' : 'false'); });
    }
    window.addEventListener('scroll', spy, { passive: true });
    spy();
    var linkrij = nav.querySelector('.ankernav__links');
    function navFade() {
      var eind = linkrij.scrollLeft + linkrij.clientWidth >= linkrij.scrollWidth - 4;
      var overloop = linkrij.scrollWidth > linkrij.clientWidth + 4;
      linkrij.classList.toggle('navlinks--eind', !overloop || eind);
    }
    linkrij.addEventListener('scroll', navFade, { passive: true });
    window.addEventListener('resize', navFade);
    navFade();
  }

  /* ── marquee: statisch centreren als alles past ── */
  var mq = root.querySelector('[data-marquee]');
  if (mq) {
    var groep = mq.querySelector('[data-marquee-groep]');
    function mqPast() {
      mq.classList.toggle('mq--statisch', groep.scrollWidth <= mq.clientWidth + 2);
    }
    window.addEventListener('resize', mqPast);
    mqPast();
  }

  /* ── stickybar (mobiel): transitieloos, scroll-check i.p.v. IO ── */
  var sticky = root.querySelector('[data-sticky]');
  var koopKaart = root.querySelector('.byg--koop');
  var sheet = sticky ? sticky.querySelector('.sheet') : null;
  var scrim = sticky ? sticky.querySelector('.stickybar__scrim') : null;
  var stickyCta = sticky ? sticky.querySelector('.stickybar__cta') : null;
  if (sticky) sticky.setAttribute('inert', '');
  var stickyStand = null;
  function updateSticky() {
    if (!sticky || !koopKaart) return;
    var boven = koopKaart.getBoundingClientRect().bottom < 0;
    if (boven === stickyStand) return;
    stickyStand = boven;
    sticky.classList.toggle('is-in', boven);
    if (boven) sticky.removeAttribute('inert'); else { sluitSheet(); sticky.setAttribute('inert', ''); }
  }
  window.addEventListener('scroll', updateSticky, { passive: true });
  window.addEventListener('resize', updateSticky);
  updateSticky();
  function openSheet() {
    if (!sheet) return;
    sheet.classList.add('is-open');
    sheet.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('is-open');
    if (stickyCta) stickyCta.setAttribute('aria-expanded', 'true');
    var eerste = sheet.querySelector('.mpick__b');
    if (eerste) eerste.focus();
  }
  function sluitSheet() {
    if (!sheet || !sheet.classList.contains('is-open')) return;
    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.classList.remove('is-open');
    if (stickyCta) { stickyCta.setAttribute('aria-expanded', 'false'); stickyCta.focus(); }
  }
  /* R5: de balk bestaat nu ook op desktop, en dáár staat de kleurkeuze-sheet op
     display:none. Een knop die een onzichtbare dialoog opent doet niets, dus beslist de
     knop per situatie: is de sheet echt bruikbaar (mobiel, en kleurwissel aan) dan opent
     hij die, anders voegt hij rechtstreeks toe via het verborgen ATC-formulier — hetzelfde
     pad als de knop in het koopblok. De aria-rol verhuist mee; aria-haspopup="dialog"
     laten staan waar niets opengaat is een onwaarheid tegen een schermlezer. */
  function sheetBruikbaar() {
    return !!sheet && getComputedStyle(sheet).display !== 'none';
  }
  function stickyKoop() {
    if (!atcForm) return;
    if (typeof atcForm.requestSubmit === 'function') atcForm.requestSubmit();
    else atcForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  }
  function stickyRol() {
    if (!stickyCta) return;
    if (sheetBruikbaar()) {
      stickyCta.setAttribute('aria-haspopup', 'dialog');
      if (!stickyCta.hasAttribute('aria-expanded')) stickyCta.setAttribute('aria-expanded', 'false');
    } else {
      stickyCta.removeAttribute('aria-haspopup');
      stickyCta.removeAttribute('aria-expanded');
    }
  }
  if (stickyCta) stickyCta.addEventListener('click', function () {
    if (sheetBruikbaar()) openSheet(); else stickyKoop();
  });
  window.addEventListener('resize', stickyRol);
  stickyRol();
  if (scrim) scrim.addEventListener('click', sluitSheet);
  if (sheet) sheet.querySelector('.sheet__close').addEventListener('click', sluitSheet);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') sluitSheet(); });

  /* ── FAQ: pills + accordeon ── */
  var acc = root.querySelector('.acc--onderwerpen');
  [].slice.call(root.querySelectorAll('.faqpill')).forEach(function (pill) {
    pill.addEventListener('click', function () {
      [].slice.call(root.querySelectorAll('.faqpill')).forEach(function (p) { p.setAttribute('aria-pressed', p === pill ? 'true' : 'false'); });
      if (acc) acc.setAttribute('data-active-topic', pill.getAttribute('data-topic'));
    });
  });
  [].slice.call(root.querySelectorAll('.acc__btn')).forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.acc__item');
      var open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ── specificaties: ARIA-tabs ── */
  var pdet = root.querySelector('[data-pdet-tabs]');
  if (pdet) {
    pdet.classList.add('pdet--js');
    var tabs = [].slice.call(pdet.querySelectorAll('.pdet__tab'));
    var panelen = [].slice.call(pdet.querySelectorAll('.pdet__panel'));
    function kiesTab(tab) {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
      panelen.forEach(function (p) { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { kiesTab(t); }); });
    kiesTab(tabs[0]);
  }

  /* ── zones: dot <-> item-synchronisatie ── */
  var zones = root.querySelector('[data-zones]');
  if (zones) {
    var chips = [].slice.call(zones.querySelectorAll('[data-zone-chip]'));
    var items = [].slice.call(zones.querySelectorAll('.zones__item'));
    var zrail = zones.querySelector('[data-zones-rail]');
    function zetZone(i) {
      chips.forEach(function (c, n) { c.classList.toggle('is-actief', n === i); });
      items.forEach(function (it, n) { it.setAttribute('aria-current', n === i ? 'true' : 'false'); });
    }
    chips.forEach(function (c, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'zones__chipbtn';
      /* de chips-lijst is aria-hidden (decoratieve laag) — knop niet tabbable */
      btn.tabIndex = -1;
      btn.setAttribute('aria-hidden', 'true');
      btn.addEventListener('click', function () {
        zetZone(i);
        if (zrail && window.innerWidth < 1024) {
          var it = items[i];
          zrail.scrollTo({ left: it.offsetLeft - zrail.offsetLeft, behavior: motionOk ? 'smooth' : 'auto' });
        }
      });
      c.appendChild(btn);
    });
    items.forEach(function (it, i) {
      it.addEventListener('mouseenter', function () { zetZone(i); });
      it.addEventListener('focusin', function () { zetZone(i); });
    });
    zetZone(0);
  }

  /* ── Van dichtbij-rail: pijlen per slide, alleen zichtbaar bij overloop
     (port van custom-stoel-v2.js initVpRail; zonder JS een native scroller). ── */
  function initVpRail(rail) {
    var wrap = rail.closest('.wrap');
    var nav2 = wrap ? wrap.querySelector('[data-rail-nav]') : null;
    if (!nav2) return;
    var prev = nav2.querySelector('[data-rail-prev]');
    var next = nav2.querySelector('[data-rail-next]');
    if (!prev || !next) return;
    function stap() {
      var s = rail.querySelector('.vp-slide, .cl-slide');
      var gap = 16;
      return s ? s.getBoundingClientRect().width + gap : rail.clientWidth;
    }
    function update() {
      var overloopt = rail.scrollWidth > rail.clientWidth + 1;
      nav2.hidden = !overloopt;
      if (!overloopt) return;
      prev.disabled = rail.scrollLeft <= 1;
      next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 1;
    }
    function schuif(richting) {
      if (typeof rail.scrollBy === 'function') {
        rail.scrollBy({ left: richting * stap(), behavior: motionOk ? 'smooth' : 'auto' });
      } else {
        rail.scrollLeft += richting * stap();
      }
    }
    prev.addEventListener('click', function () { schuif(-1); });
    next.addEventListener('click', function () { schuif(1); });
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  [].slice.call(root.querySelectorAll('[data-vp-rail]')).forEach(initVpRail);

  /* ── demovideo-slot ──────────────────────────────────────────────────────
     r4/W4: de klik-laag bestaat alleen als er een video ACHTER zit. Zonder
     video_url rendert de sectie een <figure> zonder data-video-url, en dan
     wordt hier niets meer gebonden. De oude terugval — een klik die
     toast('De video volgt.') gaf — is weg: dat was een statuslabel over onze
     eigen planning, precies wat HANDOFF-R4 §5.1 van de klantpagina haalt. */
  var vposter = root.querySelector('.vtx__video[data-video-url]');
  if (vposter) {
    vposter.addEventListener('click', function () {
      var url = vposter.getAttribute('data-video-url');
      if (!url) { return; }
      var vid = document.createElement('video');
      vid.controls = true; vid.autoplay = true; vid.playsInline = true;
      vid.src = url;
      vid.style.width = '100%'; vid.style.height = '100%'; vid.style.objectFit = 'cover';
      vposter.replaceChildren(vid);
      var p = vid.play(); if (p && p.catch) p.catch(function () {});
    });
  }

  /* ── upsell-info-popup (stoelen-idioom; data + variant-id's uit Shopify) ── */
  (function () {
    var dlg = document.querySelector('[data-dlg-xs]');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    var body = dlg.querySelector('[data-xsd-body]');
    var VINK = '<svg class="ic" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><use href="#i-vink-rond"/></svg>';
    var prod = null, gekozen = 0, opener = null;
    function varianten(p) {
      return (p.varianten || []).filter(function (v) { return v.beschikbaar !== false; });
    }
    function prijsNu() { var vs = varianten(prod); return vs[gekozen] ? vs[gekozen].prijs : prod.prijs; }
    function bouw() {
      var vs = varianten(prod);
      var h = '<button type="button" class="dlg__close" data-xsd-close aria-label="Sluiten">' +
        '<svg class="ic" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><use href="#i-sluiten"/></svg></button>' +
        '<div class="xsd__head"><img class="xsd__img" src="' + (prod.img || '') + '" alt="" width="84" height="84">' +
        '<div class="xsd__ht"><h2>' + prod.naam + '</h2><p class="xsd__intro">' + (prod.sub || '') + '</p></div></div>';
      if (prod.bullets && prod.bullets.length) {
        h += '<ul class="xsd__usps">' + prod.bullets.map(function (b) { return '<li>' + VINK + '<span>' + b + '</span></li>'; }).join('') + '</ul>';
      }
      if (vs.length > 1) {
        h += '<div class="xsd__group"><span class="xsd__label" id="xsd-g0">' + (prod.asLabel || 'Uitvoering') + '</span><div class="xsd__opts" role="group" aria-labelledby="xsd-g0">';
        vs.forEach(function (v, i) {
          var isSel = gekozen === i;
          h += '<button type="button" class="xsd__opt' + (isSel ? ' is-sel' : '') + '" aria-pressed="' + isSel + '" data-keuze="' + i + '">' + v.naam +
            '<span class="xsd__optp">' + euro(v.prijs) + '</span></button>';
        });
        h += '</div></div>';
      }
      h += '<div class="xsd__acts"><button type="button" class="btn btn--primary" data-xsd-add>In winkelwagen, <span data-xsd-prijs>' + euro(prijsNu()) + '</span></button>';
      if (prod.url) h += '<a class="btn btn--ghost" href="' + prod.url + '">Bekijk de productpagina</a>';
      h += '</div>';
      body.innerHTML = h;
    }
    function open(key, op) {
      prod = (DATA.accessoires || []).filter(function (a) { return String(a.key) === String(key); })[0];
      if (!prod) return;
      opener = op || null;
      gekozen = 0;
      bouw();
      dlg.showModal();
    }
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-xs-info]');
      if (t) { e.preventDefault(); open(t.getAttribute('data-xs-info'), t); return; }
      var kaart = e.target.closest('.buyupc');
      if (kaart && !e.target.closest('button,a')) {
        var b = kaart.querySelector('[data-xs-info]');
        if (b) open(b.getAttribute('data-xs-info'), b);
      }
    });
    dlg.addEventListener('click', function (e) {
      var opt = e.target.closest('.xsd__opt');
      if (opt) {
        gekozen = parseInt(opt.getAttribute('data-keuze'), 10);
        [].slice.call(dlg.querySelectorAll('.xsd__opt')).forEach(function (o) {
          var on = o === opt;
          o.classList.toggle('is-sel', on);
          o.setAttribute('aria-pressed', String(on));
        });
        var pe = dlg.querySelector('[data-xsd-prijs]');
        if (pe) pe.textContent = euro(prijsNu());
        return;
      }
      if (e.target.closest('[data-xsd-close]')) { dlg.close(); return; }
      if (e.target.closest('[data-xsd-add]')) {
        var vs = varianten(prod);
        var v = vs[gekozen] || vs[0];
        dlg.close();
        if (v) toevoegen([{ id: v.variantId, quantity: 1 }], prod.naam + (vs.length > 1 ? ' (' + v.naam + ')' : ''));
        return;
      }
      if (e.target === dlg) dlg.close();
    });
    dlg.addEventListener('close', function () { if (opener && document.contains(opener)) opener.focus(); });
  })();
})();
